/**
 * @generated SignedSource<<b82fb8dc15f1917de631e934dc801b9c>>
 * @relayHash 8004e021c1c5bcbbc810cd521b82d028
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8004e021c1c5bcbbc810cd521b82d028

import { ConcreteRequest } from 'relay-runtime';
export type Ch_deleteRecommendedMedicationInput = {
  id: string;
};
export type chDeleteRecommendedMedicationMutation$variables = {
  connections: ReadonlyArray<string>;
  input: Ch_deleteRecommendedMedicationInput;
};
export type chDeleteRecommendedMedicationMutation$data = {
  readonly chDeleteRecommendedMedication: {
    readonly ch_RecommendedMedication: {
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type chDeleteRecommendedMedicationMutation = {
  response: chDeleteRecommendedMedicationMutation$data;
  variables: chDeleteRecommendedMedicationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "chDeleteRecommendedMedicationMutation",
    "selections": [
      {
        "alias": "chDeleteRecommendedMedication",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_deleteRecommendedMedicationPayload",
        "kind": "LinkedField",
        "name": "ch_deleteRecommendedMedication",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_RecommendedMedication",
            "kind": "LinkedField",
            "name": "ch_RecommendedMedication",
            "plural": false,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "chDeleteRecommendedMedicationMutation",
    "selections": [
      {
        "alias": "chDeleteRecommendedMedication",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_deleteRecommendedMedicationPayload",
        "kind": "LinkedField",
        "name": "ch_deleteRecommendedMedication",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_RecommendedMedication",
            "kind": "LinkedField",
            "name": "ch_RecommendedMedication",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "8004e021c1c5bcbbc810cd521b82d028",
    "metadata": {},
    "name": "chDeleteRecommendedMedicationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "729dbf9a56f0fb443b01dc23adbcfe3c";

export default node;
